import { db } from '@/utils/Firebase'

export const CALENDAR_HISTORY = 'calendar'

const IN_LIMIT = 10

const BATCH_LIMIT = 450

const chunk = (list, size) => {
    const out = []
    for (let i = 0; i < list.length; i += size) out.push(list.slice(i, i + size))
    return out
}

const collect = (target, collection, snapshot) => {
    snapshot.docs.forEach(doc => { target[`${collection}/${doc.id}`] = doc.data() })
}

export const captureCalendarDays = async (scope, dates = []) => {
    const days = [...new Set(dates.filter(Boolean))]
    const docs = {}
    if (!scope || !days.length) return docs
    const queries = []

    if (scope.collection === 'assignedRoutines') {
        if (!scope.studentId) return docs
        chunk(days, IN_LIMIT).forEach(part => {
            queries.push(db.collection('assignedRoutines')
                .where('studentId', '==', scope.studentId)
                .where('rawDate.full', 'in', part)
                .get()
                .then(snap => collect(docs, 'assignedRoutines', snap)))
        })
    } else {
        if (!scope.groupId && scope.groupId !== 0) return docs
        chunk(days, IN_LIMIT).forEach(part => {
            queries.push(db.collection('groupAssignedRoutines')
                .where('teamId', '==', scope.teamId || null)
                .where('groupId', '==', scope.groupId)
                .where('rawDate.full', 'in', part)
                .get()
                .then(snap => collect(docs, 'groupAssignedRoutines', snap)))
        })
        const students = [...new Set((scope.students || []).filter(Boolean))]
        days.forEach(date => {
            chunk(students, IN_LIMIT).forEach(part => {
                queries.push(db.collection('assignedRoutines')
                    .where('studentId', 'in', part)
                    .where('rawDate.full', '==', date)
                    .get()
                    .then(snap => collect(docs, 'assignedRoutines', snap)))
            })
        })
    }

    await Promise.all(queries)
    return docs
}

export const diffCalendarDays = (before = {}, after = {}) => {
    const keys = new Set([...Object.keys(before), ...Object.keys(after)])
    const changes = []
    keys.forEach(path => {
        const prev = before[path] || null
        const next = after[path] || null
        if (JSON.stringify(prev) === JSON.stringify(next)) return
        changes.push({ path, before: prev, after: next })
    })
    return changes
}

export const restoreCalendarDays = async (changes = [], side = 'before') => {
    for (const part of chunk(changes, BATCH_LIMIT)) {
        const batch = db.batch()
        part.forEach(change => {
            const [collection, id] = change.path.split('/')
            const ref = db.collection(collection).doc(id)
            const data = change[side]
            if (data) batch.set(ref, data)
            else batch.delete(ref)
        })
        await batch.commit()
    }
}
